// Lightweight pub/sub store that lets detail pages report a friendly
// display name for the entity id in their URL, so the global Breadcrumbs
// component can render "Category Name" instead of a raw UUID.
//
// Keys are namespaced by the parent URL segment ("asn/123", "outbound/123")
// so the same numeric id in different entity types can never collide.
//
// Usage (in a detail page, after the entity is fetched):
//   import { setBreadcrumbName } from '../../utils/breadcrumbNames';
//   useEffect(() => { if (entity?.name) setBreadcrumbName(`things/${id}`, entity.name); }, [entity, id]);
//
// The Breadcrumbs component subscribes via subscribeBreadcrumbNames and
// looks up names by the raw URL segment.

const names = new Map();
const listeners = new Set();

export const setBreadcrumbName = (idSegment, name) => {
  if (!idSegment || !name) return;
  const key = String(idSegment);
  if (names.get(key) === name) return;
  names.set(key, name);
  listeners.forEach((fn) => fn());
};

export const getBreadcrumbName = (idSegment) => names.get(String(idSegment));

export const subscribeBreadcrumbNames = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
